<template>
  <div class="f360-date-picker">
    <p
      class="f360-date-picker__label"
      :class="{ 'f360-date-picker__label--full': full }"
      v-if="label"
    >
      {{ label }}
    </p>

    <el-date-picker
      v-bind="$attrs"
      :class="{
        'f360-date-picker--error': error,
        'f360-date-picker--disabled': disabled
      }"
      :disabled="disabled"
    />
  </div>
</template>

<script lang="ts" setup>
defineProps<{
  label?: string;
  error?: boolean;
  full?: boolean;
  disabled?: boolean;
}>();
</script>

<style lang="scss">
@use "@/ui/styles/variables" as *;
@use "@/ui/styles/theme/f360-theme" as *;

@use "sass:map" as map;

.f360-date-picker {
  $font-size: 12px;
  $placeholder-bg: #6d6d6d;
  width: 100%;

  .financas-date-editor.financas-input,
  .financas-date-editor.financas-input__wrapper {
    width: 100%;
  }

  @mixin date-picker-input {
    font-family: $fontFamily;
    font-size: $font-size;
    line-height: $text-line-height;
    color: map.get($neutro, 950);
    font-weight: normal;
  }

  .financas-date-editor.financas-range-input {
    @include date-picker-input;
  }

  .financas-input__inner {
    @include date-picker-input;
  }
  .financas-date-editor.financas-input,
  .financas-date-editor.financas-input__wrapper {
    width: 100%;
  }

  .financas-date-editor .financas-range-input {
    @include date-picker-input;
  }

  .financas-input__inner {
    @include date-picker-input;
  }

  &__label {
    font-family: $fontFamily;
    font-weight: 400;
    font-size: 12px;
    line-height: 16px;
    margin: 0 0 8px;
    text-wrap: nowrap;
  }

  &--full {
    width: 100%;
  }

  &--error {
    .financas-input {
      &__wrapper {
        box-shadow: none;
        border: 1px solid #ed1517;

        &:hover {
          background-color: #fff1f1;
        }
      }
    }
  }

  &--disabled {
    .financas-input {
      &__wrapper {
        background-color: #f5f7fa !important;
        box-shadow: 0 0 0 1px #e4e7ed inset !important;

        &:hover {
          background-color: #f5f7fa !important;
        }

        &:focus-within {
          border: 1px solid $input-border !important;
        }
      }
    }
  }

  .financas-range-input {
    font-weight: 500;
    font-size: $font-size;

    &::placeholder {
      @include date-picker-input;
      color: $placeholder-bg;
      opacity: 0.5;
    }
  }

  .financas-range-editor.financas-input__wrapper {
    box-sizing: border-box;
    width: 100%;
    border-width: 1px;
  }
}

.f360-baseform {
  .f360-date-picker {
    .financas-input__wrapper {
      background-color: #fff;
      border-radius: 5px;
      box-sizing: border-box;

      .financas-input {
        &__inner {
          font-family: $fontFamily !important;
          font-size: 12px;
          line-height: 16px;
        }

        &__wrapper {
          border-radius: 5px !important;
          border: none !important;
          box-shadow: none !important;
          background-color: transparent;

          &:focus {
            border: 1px solid $input-border-active;
          }
        }
      }

      &:hover {
        background-color: #edf7ff;
      }
    }
  }
}
</style>
